import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appAutoupperCase]'
})
export class AutoupperCaseDirective {
  keyEntered: boolean = false;

  constructor(private el: ElementRef) { }
  @Input('appAutoupperCase') appInputRestriction: string;
  @HostListener('input', ['$event']) onInputChange(event: Event) {
    debugger
    if (this.keyEntered != true) {
      const input = event.target as HTMLInputElement;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      this.el.nativeElement.value = input.value.toUpperCase();
      if (start !== null && end !== null) {
        this.el.nativeElement.setSelectionRange(start, end); // preserve cursor position
      }
    }
  }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    debugger
    this.keyEntered = false;
    if (
      /*this.navigationKeys.indexOf(event.key) > -1 ||*/ // Allow: navigation keys: backspace, delete, arrows etc.
      (event.key === 'a' && event.ctrlKey === true) || // Allow: Ctrl+A
      (event.key === 'c' && event.ctrlKey === true) || // Allow: Ctrl+C
      (event.key === 'v' && event.ctrlKey === true) || // Allow: Ctrl+V
      (event.key === 'x' && event.ctrlKey === true) || // Allow: Ctrl+X
      (event.key === 'a' && event.metaKey === true) || // Allow: Cmd+A (Mac)
      (event.key === 'c' && event.metaKey === true) || // Allow: Cmd+C (Mac)
      (event.key === 'v' && event.metaKey === true) || // Allow: Cmd+V (Mac)
      (event.key === 'x' && event.metaKey === true) || // Allow: Cmd+X (Mac)
      (event.key === 'z' && event.metaKey === true) ||
      (event.key === 'z' && event.ctrlKey === true) // for ctrl - z
    ) {
      // let it happen, don't do anything
      return;
    }

    if (this.appInputRestriction === 'enter') {
      this.enter(event);
    }
  }
  enter(event: any) {
    debugger
    this.keyEntered = true
    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    if ((event.keyCode === 13)) {
      e.preventDefault();
    }
  }
}

